import { render, staticRenderFns } from "./RoleAccount.vue?vue&type=template&id=14902ea0&"
import script from "./RoleAccount.vue?vue&type=script&lang=js&"
export * from "./RoleAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports